import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

import { redirectTo } from '../../utils';
import UserModel from '../../models/User';
import OnboardingModel from '../../models/Onboarding';
import Preloader from '../../utils/Preloader';
import { AdvertisingView } from '../../views';

// Import Onboarding steps
import SetupAccount from './steps/SetupAccount';
import PasswordReset from './steps/PasswordReset';
import PasswordResetConfirmation from './steps/PasswordResetConfirmation';
import NoMatchStartPlaying from './steps/NoMatchStartPlaying';
import MatchStartPlaying from './steps/MatchStartPlaying';
import LinkAccount from './steps/LinkAccount';
import DidYouPlay from './steps/DidYouPlay';

// Used to change backgrounds on each step of onboarding
const bg_classes = [
	'bg-1',
	'bg-2',
	'bg-3',
	'bg-4',
	'bg-5',
	'bg-6'
];

export class OnboardingView extends View {

	get template() {
		return template;
	}

	get className() {
		return "onboarding-page modal-overlay";
	}

	regions() {
		return {
			formContainer: '.form-container',
			advert: '.advert'
		}
	}

	ui() {
		return {
			back: '.js-back'
		};
	}

	events() {
		return {
			'click @ui.back': 'goBack'
		};
	}

	modelEvents() {
		return {
			'change:current_step': 'changeCurrentStep'
		};
	}

	childViewEvents() {
		return {
		};
	}

	async initialize() {
		this.setListeners();

		this.model = new OnboardingModel();
		this.model.set({
			game_title: this.getOption('game_title'),
			background: bg_classes[0],
			show_back_button: false
		});

		// If Identity token has been set
		if (UserModel.get('identity_token')) {
			if (this.model.get('current_step')) {
				this['show' + this.model.get('current_step')]();
			}
			// If onboarding process hasn't started then check for matching Fanhub account
			else {
				Preloader.show();
				await UserModel.checkNRLAccountUserHasExistingFanhubAccount();
				Preloader.hide();
			}
		}
		// Redirect to home to go through authentication process
		else {
			// for some reason this isn't changing controllers on redirect,
			// it stays on the onboarding layout.
			// redirectTo();
			location.assign(location.origin); // this is a hack, i want to fix this.
		}
	}

	setListeners() {
		this.listenTo(
			UserModel,
			'user:checkNRLAccountUserHasExistingFanhubAccount:success',
			this.checkNRLAccountUserHasExistingFanhubAccountSuccess
		);
		this.listenTo(
			UserModel,
			'user:checkNRLAccountUserHasExistingFanhubAccount:fail',
			this.checkNRLAccountUserHasExistingFanhubAccountFail
		);
	}

	checkNRLAccountUserHasExistingFanhubAccountSuccess(result) {
		this.model.set(result);
		this.showSetupAccount();
	}

	checkNRLAccountUserHasExistingFanhubAccountFail(errors) {
		const error_code = errors[0].code;

		if (error_code === 404 || error_code === 401) {
			this.showNoMatchStartPlaying();
			// this.showDidYouPlay();
			return;
		}

		// if generic error
		alert(
			'Something went wrong while checking if you played NRL Fantasy in previous years: ' +
			errors[0].text
		);
	}

	/**
	 * Show a step view in the delegated page region
	 *
	 * @param {Marionette.View} view
	 * @param {String} background Background class
	 * @param {Object} options Option properties: { show_back_button: Boolean }
	 * @memberof OnboardingView
	 */
	showStep(view, background, { show_back_button = true } = {}) {
		this.model.set({
			background,
			show_back_button
		});
		this.render();
		this.getRegion('formContainer').show(new view({
			onboarding: this.model
		}));
		const advertising = new AdvertisingView({
			ad_id: 'div-gpt-ad-1610421948488-0',
			ad_path:'game-selector',
			size: [[300, 250], [1,1]],
			pos: 2,
		});
		this.getRegion('advert').show(advertising)
	}

	showSetupAccount() {
		this.showStep(SetupAccount, bg_classes[0]);
	}

	showDidYouPlay() {
		this.showStep(DidYouPlay, bg_classes[4]);
	}

	showLinkAccount() {
		this.showStep(LinkAccount, bg_classes[2]);
	}

	showPasswordReset() {
		this.showStep(PasswordReset, bg_classes[3]);
	}

	showPasswordResetConfirmation() {
		this.showStep(PasswordResetConfirmation, bg_classes[3]);
	}

	showNoMatchStartPlaying() {
		this.showStep(NoMatchStartPlaying, bg_classes[5]);
	}

	showMatchStartPlaying() {
		this.showStep(MatchStartPlaying, bg_classes[1]);
	}

	changeCurrentStep(model, value) {
		if (value === undefined) return;
		this['show' + value]();
	}

	goBack() {
		const current_step = this.model.get('current_step');
		const current_step_back = this.model.get(`${current_step}_back_url`);

		if (current_step_back) {
			this.model.set({
				'current_step': current_step_back
			});
		}
		else {
			redirectTo();
			this.destroy();
		}
	}
}

export default OnboardingView;